<script setup lang="ts">
const { state } = useAppStore()
const localePath = useLocalePath()
const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const route = useRoute()

const availableLocales = computed(() => {
    return (locales.value).filter((i) => i !== locale.value)
})

const isMobileMenuOpen = ref(false)

watch(() => route.path, () => {
    isMobileMenuOpen.value = false
})
</script>

<template>
    <header
        role="banner"
        class="sticky top-0 py-2.5 bg-chsc-indigo-500 z-20 px-9"
    >
        <UiContainer :max-width="'max-w-full'">
            <div class="flex items-center">
                <NuxtLink :to="localePath('/')">
                    <img src="https://a.storyblok.com/f/331854/113x48/392a69ec01/chocolate-scorecard.svg">
                </NuxtLink>
                <div class="flex-1 flex justify-end">
                    <nav
                        :class="[
                            'flex-1 flex justify-end max-[1025px]:fixed max-[1025px]:top-0 max-[1025px]:left-0 max-[1025px]:w-full max-[1025px]:h-full max-[1025px]:bg-chsc-indigo-500 max-[1025px]:z-10 max-[1025px]:flex max-[1025px]:items-center max-[1025px]:justify-center',
                            isMobileMenuOpen ? 'max-[1025px]:translate-x-0' : 'max-[1025px]:translate-x-full',
                        ]"
                    >
                        <ul class="flex items-center gap-6 max-[1281px]:gap-3 max-[1025px]:flex-col max-[1025px]:gap-2">
                            <li
                                v-for="item in state.menu"
                                :key="item._uid"
                                class="flex items-center gap-6 after:content-[''] after:block after:w-[3px] after:h-[3px] after:bg-white after:rounded-full last:after:hidden max-[1281px]:gap-3 max-[1025px]:after:hidden"
                            >
                                <NuxtLink
                                    :to="localePath(`/${item.url}`)"
                                    class="fs-xs font-monsterrat font-bold uppercase text-white hover:opacity-90 max-[1025px]:fs-2xl!"
                                >
                                    <span>{{ item.label }}</span>
                                </NuxtLink>
                            </li>
                        </ul>
                    </nav>
                    <div class="ml-8 flex items-center gap-1.5">
                        <UPopover :ui="{ content: 'ring-none' }">
                            <UButton
                                :label="locale"
                                trailing-icon="i-heroicons-chevron-down"
                                size="sm"
                            />
                            <template #content>
                                <div class="bg-chsc-indigo-500 border-none py-1.5">
                                    <div
                                        v-for="lang in availableLocales"
                                        :key="lang"
                                        class="px-1.5"
                                    >
                                        <NuxtLink
                                            :to="switchLocalePath(lang)"
                                            class="rounded-md px-8 py-1 block text-white text-sm font-semibold uppercase hover:bg-chsc-indigo-300"
                                        >
                                            {{ lang }}
                                        </NuxtLink>
                                    </div>
                                </div>
                            </template>
                        </UPopover>
                        <button
                            :class="[
                                'hidden relative z-10 flex-col gap-1 cursor-pointer [&>span]:relative [&>span]:w-[25px] [&>span]:h-px [&>span]:bg-white hover:opacity-80 max-[1025px]:flex',
                                isMobileMenuOpen ? '[&>span:first-child]:top-[2px] [&>span:first-child]:rotate-45 [&>span:last-child]:top-[-3px] [&>span:last-child]:-rotate-45' : '[&>span:first-child]:top-0 [&>span:first-child]:rotate-0 [&>span:last-child]:-top-0 [&>span:last-child]:rotate-0',
                            ]"
                            @click="isMobileMenuOpen = !isMobileMenuOpen"
                        >
                            <span />
                            <span />
                        </button>
                    </div>
                </div>
            </div>
        </UiContainer>
    </header>
</template>
